// @flow

export const GET_CONTENT = 'GET_CONTENT';
export const GET_CONTENT_DONE = 'GET_CONTENT_DONE';
